import React from 'react';
import { Card, Button, Alert, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';

const Templates: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Templates - MyCinemas Admin Panel</title>
      </Helmet>

      <div className="fade-in">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h2 className="mb-1">Email Templates</h2>
            <p className="text-muted mb-0">Manage email templates for marketing campaigns</p>
          </div>
          <Button 
            variant="primary"
            href="https://app.brevo.com/templates"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="bi-box-arrow-up-right me-1"></i>
            Open Brevo Templates
          </Button>
        </div>

        <Alert variant="info" className="mb-4">
          <h6>
            <i className="bi-info-circle me-2"></i>
            Templates are managed in Brevo
          </h6>
          <p className="mb-0">
            All email templates are created and managed in the{' '}
            <a href="https://app.brevo.com/templates" target="_blank" rel="noopener noreferrer">
              Brevo Dashboard
            </a>.
            This provides access to:
          </p>
          <ul className="mb-0 mt-2">
            <li>Rich template editor with drag-and-drop</li>
            <li>Template variables and personalization</li>
            <li>Template preview and testing</li>
            <li>Template library and categories</li>
            <li>A/B testing capabilities</li>
          </ul>
        </Alert>

        <Card>
          <Card.Body className="text-center py-5">
            <i className="bi-envelope-check display-1 text-primary mb-3"></i>
            <h4>Manage Templates in Brevo</h4>
            <p className="text-muted mb-4">
              Create, edit, and manage all your email templates directly in Brevo's powerful template editor.
            </p>
            <div className="d-flex justify-content-center gap-3">
              <Button 
                variant="primary"
                size="lg"
                href="https://app.brevo.com/templates"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi-box-arrow-up-right me-2"></i>
                Go to Brevo Templates
              </Button>
              <Button 
                variant="outline-primary"
                size="lg"
                href="https://app.brevo.com/campaigns"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi-megaphone me-2"></i>
                Create Campaign
              </Button>
            </div>
          </Card.Body>
        </Card>

        <Card className="mt-4">
          <Card.Header>
            <h5 className="mb-0">Quick Links</h5>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md={4}>
                <Card className="h-100 border-0 bg-light">
                  <Card.Body>
                    <h6>
                      <i className="bi-envelope me-2 text-primary"></i>
                      Email Templates
                    </h6>
                    <p className="text-muted small mb-2">
                      Create and manage email templates
                    </p>
                    <Button 
                      variant="outline-primary" 
                      size="sm"
                      href="https://app.brevo.com/templates"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Open <i className="bi-box-arrow-up-right ms-1"></i>
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={4}>
                <Card className="h-100 border-0 bg-light">
                  <Card.Body>
                    <h6>
                      <i className="bi-megaphone me-2 text-success"></i>
                      Campaigns
                    </h6>
                    <p className="text-muted small mb-2">
                      Create and send marketing campaigns
                    </p>
                    <Button 
                      variant="outline-success" 
                      size="sm"
                      href="https://app.brevo.com/campaigns"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Open <i className="bi-box-arrow-up-right ms-1"></i>
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={4}>
                <Card className="h-100 border-0 bg-light">
                  <Card.Body>
                    <h6>
                      <i className="bi-people me-2 text-info"></i>
                      Contacts & Segments
                    </h6>
                    <p className="text-muted small mb-2">
                      Manage contacts and create segments
                    </p>
                    <Button 
                      variant="outline-info" 
                      size="sm"
                      href="https://app.brevo.com/contacts"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Open <i className="bi-box-arrow-up-right ms-1"></i>
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default Templates;
